import type { SVGProps } from "react";
import * as React from "react";
const SvgMicrosoftWord = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#7AC6FF" d="M4 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3H4V4Z" />
    <path fill="#1C91FF" d="M4 12h16v5H4z" />
    <path fill="#4BABFF" d="M4 7h16v5H4z" />
    <path fill="#137FE3" d="M4 17h16v3a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3Z" />
    <path
      fill="#0A63B6"
      d="M2.833 7h8.334c.46 0 .833.373.833.833v8.334c0 .46-.373.833-.833.833H2.833A.833.833 0 0 1 2 16.167V7.833c0-.46.373-.833.833-.833Z"
    />
    <path
      fill="#fff"
      d="M5.243 13.54c.019.143.03.267.036.373H5.3c.008-.1.025-.222.05-.364.026-.142.05-.262.07-.36l.97-4.187h1.255l1.007 4.124c.058.256.1.516.125.778h.017c.018-.254.053-.506.104-.755L9.701 9h1.142l-1.41 6H8.099l-.957-3.973a9.329 9.329 0 0 1-.159-.85h-.017a9.005 9.005 0 0 1-.064.434c-.033.192-.059.335-.078.427L5.925 15H4.568L3.15 9.002h1.163l.874 4.195c.02.087.038.201.056.343Z"
    />
  </svg>
);
export default SvgMicrosoftWord;
